import { Component, OnInit, ElementRef, ViewChild  } from '@angular/core';
import { AccountService, InstoreService } from '@app/_services'; 
import { UntypedFormBuilder, FormGroup, Validators } from '@angular/forms';
import { timer } from 'rxjs';
import { Renderer2 } from '@angular/core';
import {Router, NavigationExtras} from "@angular/router"
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})
export class MapComponent implements OnInit {



  @ViewChild('gmap', { static: false }) gmapElement: ElementRef;
   map: google.maps.Map;

  City: any = ['Option 1', 'Option 2', 'Option 3'];
  AssetsDataLists;
  CreativeDataLists;
  RegionDataLists;
  ShowroomDataLists;
  VendorDataLists;
  selectedRegion :String;
  f_Region_Showroom_list;

  HoardingLists;

  isLoading = false;
  isShowTab = true;

  markers = [];
  markersArray = [];

  selected_region_id :number;
  selected_region_name :string;
  user_role_id:number;
  user_region_id: number=0;
  user_showroom_id: number=0;
  selected_showroom_id :number;
  selected_showroom_name :string;

  filter_showroom_HoardingLists;
  filter_tc_HoardingLists; //tc for type creative                                        
  selAssetTypeValue = -1;
  selCreativeValue = -1;  

  selHoarding: any;

    //Default Marker
    marker = new google.maps.Marker({
      // position: new google.maps.LatLng(13.0405026, 80.2336924),
      // map: this.map,
      // title: "Hello World!"
    });

    constructor(private formBuilder: UntypedFormBuilder,
      private accountService: AccountService,
      private router: Router,
      private instoreService: InstoreService,
      private renderer: Renderer2) {
 
       }
  
    ngOnInit(): void {

      var userdata = localStorage.getItem('userInformation');
      var _data = JSON.parse(userdata);
      if(_data) {
        this.user_role_id = _data.role_id;
        this.user_region_id = _data.region_id;
        this.user_showroom_id = _data.showroom_id;

      }
  
      this.reloadAssetsLists();
      this.reloadCreativeLists();
      this.reloadRegionLists();
      this.reloadShowroomLists();
      this.reloadVendorLists();
    }
  ngAfterViewInit() {
    var mapProp = {
      center: new google.maps.LatLng(13.0405026, 80.2336924),
      zoom: 12,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };

    this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);
       //Adding Click event to default marker
       this.marker.addListener("click", () => {
            //console.log("Clicked Marker ");
            /*
              const infoWindow = new google.maps.InfoWindow({
                content: this.marker.getTitle()
              });
              infoWindow.open(this.marker.getMap(), this.marker);
            */  
      });

    //Adding default marker to map
    //this.marker.setMap(this.map);

    this.loadHoardingData()
    
     //this.map.triggerResize(); //Map not showing issue fixes
  }

  showInstoreData(regionID,regionName,showroomID,showroomName) {
    
    this.selected_region_id = regionID;
    this.selected_region_name = regionName;
    this.selected_showroom_id=showroomID;
    this.selected_showroom_name =showroomName;
  
    this.filter_showroom_HoardingLists = this.HoardingLists.filter(s => s.showroom_id === this.selected_showroom_id);
    this.filter_tc_HoardingLists = this.filter_showroom_HoardingLists;

    // console.log("---showInstoreData  ----"+this.filter_showroom_HoardingLists.length);
    this.loadAllMarkers() 
  }

  loadHoardingData() {
    this.instoreService.getHoardingLists(this.user_showroom_id)
    .pipe(first())
      .subscribe(
      (response) => {
        //this.isLoading = false;
        //this.AssetsDataLists = response.result;
        //this.clearFilter()
        this.HoardingLists = response.result;
        //this.filterInstoreLists = this.HoardingLists;
        console.log("Instore List "+ this.HoardingLists);
        this.filter_showroom_HoardingLists = this.HoardingLists;
        this.filter_tc_HoardingLists = this.HoardingLists;
        this.loadAllMarkers()  
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }

  onCreativeChange(creativeValue) {
    this.selCreativeValue = parseInt(creativeValue, 10);
    this.filterForModule()
  }

  onAssetTypeChange(assetTypeValue) {
      this.selAssetTypeValue = parseInt(assetTypeValue, 10);
      this.filterForModule()
  }

  onSearchChange(searchValue: string): void {  
    console.log(searchValue);
    this.filterLogicforTC();
    this.filter_tc_HoardingLists = this.filter_tc_HoardingLists.filter((item) => {
      var typeCondition = false;
      var creativeCondition = false;
      if(item.assetTypeName.indexOf(searchValue) >= 0) {
        typeCondition = true;
      }
      if(item.creativeName.indexOf(searchValue) >= 0) {
        creativeCondition = true;            
      }
      return typeCondition || creativeCondition;
    });
    this.loadAllMarkers()
  }

    filterLogicforTC() {
      this.filter_tc_HoardingLists = this.filter_showroom_HoardingLists.filter((item) => {
        var typeCondition = true;
        var creativeCondition = true;
        if(this.selAssetTypeValue > 0) {
          typeCondition = (item.asset_type_id == this.selAssetTypeValue);
        }
        if(this.selCreativeValue > 0) {
          creativeCondition = (item.creative_id == this.selCreativeValue);            
        }
        return typeCondition && creativeCondition;
      });
    }

    filterForModule() {
      this.filterLogicforTC();
      this.loadAllMarkers(); 
    }

  onRegionClick(id:number,regionName:string){
    this.isShowTab = !this.isShowTab;
    this.selectedRegion = regionName;
    this.f_Region_Showroom_list = this.ShowroomDataLists.filter(s => s.region_id === id);
  }
  onBackClick(){
    this.isShowTab = !this.isShowTab;
  }

  clearAllMarker() {
    for(var i=0; i<this.markersArray.length; i++){
      this.markersArray[i].setMap(null);
    }
    this.markers = [];
    this.markersArray = [];
  }
  
  loadAllMarkers(): void {
    this.clearAllMarker()
    for(var i=0;i<this.filter_tc_HoardingLists.length;i++) {
      let hoarding = this.filter_tc_HoardingLists[i];
      this.markers.push({
        position: new google.maps.LatLng(hoarding.lat, hoarding.lang),
        map: this.map,
        title: "T Nagar",
        dummyid: hoarding.id
      })
    }

    console.log("loadAllMarkersf "+this.filter_tc_HoardingLists.length);
    console.log("loadAllMarkers "+this.markers.length);

    /*
      this.markers = [
        {
          position: new google.maps.LatLng(13.0405026, 80.2336924),
          map: this.map,
          title: "T Nagar"
        },
        {
          position: new google.maps.LatLng(13.003387, 80.255043),
          map: this.map,
          title: "Adyar"
        }
      ];
    */

    this.markers.forEach(markerInfo => {
      //Creating a new marker object
      const marker = new google.maps.Marker({
        ...markerInfo
      });

      //creating a new info window with markers info
      const infoWindow = new google.maps.InfoWindow({
        content: marker.getTitle()
      });

      //Add click event to open info window on marker
      marker.addListener("click", () => {
        //infoWindow.open(marker.getMap(), marker);
        console.log("Clicked Marker "+markerInfo.dummyid);
        var tempLists = this.HoardingLists.filter(s => s.id == markerInfo.dummyid);
        if(tempLists.length > 0){
          this.selHoarding = tempLists[0]; 
        }
       });

      //Adding marker to google map
      this.markersArray.push(marker);
      marker.setMap(this.map);
    });
  }
  
  reloadAssetsLists(){
    this.accountService.getAssetsLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.AssetsDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  reloadCreativeLists(){
    this.accountService.getCreativeLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.CreativeDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  reloadRegionLists(){
    this.accountService.getRegionsLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.RegionDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
    
  }
  reloadShowroomLists(){
    this.accountService.getShowroomLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.ShowroomDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  reloadVendorLists(){
    this.accountService.getVendorLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.VendorDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }

}
